"use client";
import React, { useEffect, useState } from "react";
import ProductList from "../../components/ProductInTable/ProductList";
import stl from "./productRecommended.module.scss";
//GA统计事件
import {
    productShow,
    getProductItemParams,
    gaLoadedPromise,
} from "@/src/utils/gtagEvents";
import YouMayLike from "./YouMayLike";
import { useCommonContext, useProductDetailsContext } from "@/src/provider";
import { likeProducts } from "@/store";
import { ProductInTable } from "../../components";

interface Props {}

const ProductRecommendedClient: React.FC<React.PropsWithChildren<Props>> = (
    props,
) => {
    const { siteId } = useCommonContext();
    const [productDetail] = useProductDetailsContext((state) => [
        state.productDetail,
    ]);
    const [isPersonalize, setIsPersonalize] = useState(false);
    const [likeProductsList, getLikeProduct] =
        likeProducts.useLikeProductListStore((state) => [
            state.likeProductsList,
            state.getLikeProduct,
        ]);
    useEffect(() => {
        const searchParams = new URLSearchParams(window.location.search);
        const isPersonalizeParam = searchParams.get("is_personalize");

        if (isPersonalizeParam) {
            // 将参数值转换为布尔值
            const isPersonalize = isPersonalizeParam === "true";
            setIsPersonalize(isPersonalize);
        }
        try {
            getLikeProduct(productDetail.products_id!).then(() => {
                gaLoadedPromise().then(() => {
                    const sendData = getGAEventparams(likeProductsList);
                    sendData.length &&
                        productShow({
                            items: sendData,
                        });
                });
            });
        } catch (err) {
            console.log(err);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    //GA 统计参数
    const getGAEventparams = (list: any) => {
        const { pathname, search } = (window && window.location) || {
            pathname: "",
            search: "",
        };
        return getProductItemParams({
            productList: list,
            colorIndex: 0,
            list_name: `${pathname}${search}`,
            category: `${pathname}${search}`,
        });
    };

    return (
        <ProductInTable className={stl["page-item"]}>
            {[1, 5, 8].includes(Number(siteId)) && isPersonalize && (
                <div className={stl["you-may-like-container"]}>
                    <YouMayLike />
                </div>
            )}
            {props.children}
            <ProductList
                data={likeProductsList ? likeProductsList.slice(0, 4) : []}
                type={"like"}
            />
        </ProductInTable>
    );
};

export default ProductRecommendedClient;
